import React from 'react';
import { Route, Switch } from 'react-router';

import { Robots as MetaRobots } from 'src/shared/components/Meta';
import { Route as Routes } from 'src/shared/route';

import { Logout } from '../Logout';
import { Profile } from '../Profile';

const Router = () => (
  <>
    <MetaRobots mode="none" />
    <Switch>
      <Route path={Routes.INTERNAL_PROFILE.path}>
        <Profile />
      </Route>
      <Route path={Routes.INTERNAL_LOGOUT.path}>
        <Logout />
      </Route>
    </Switch>
  </>
);

export { Router };
